import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";

// AR-24  Patient-facing questionnaire API (public; token + תז).
@Injectable({ providedIn: "root" })
export class QuestionnaireService {
  constructor(private http: HttpClient) {}

  getByCode(code: string) {
    return this.http.get(`api/questionnaire/${encodeURIComponent(code)}`);
  }

  verify(code: string, ID: string) {
    return this.http.post(`api/questionnaire/${encodeURIComponent(code)}/verify`, { ID });
  }

  submit(code: string, ID: string, language: string, answers: any[]) {
    return this.http.post(`api/questionnaire/${encodeURIComponent(code)}/submit`, {
      ID,
      language,
      answers,
    });
  }
}
